module.exports = __webpack_public_path__ + "static/media/400143_01.847396b5.png";